module.exports = __webpack_public_path__ + "img/yarn-trading.66f9705b.svg";